import apiClient from "./apiClient";

const fetchCbdCoursesById = async (courseId, params) => {
  const response = await apiClient.get(
    `/cpd/courses/${courseId}?${new URLSearchParams(params)}`
  );
  return response.data;
};

const fetchCpdContentCourses = async (params) => {
  const response = await apiClient.get(
    // https://nodejs.org/api/url.html#class-urlsearchparams
    `/cpd/courses?${new URLSearchParams(params)}`
  );
  return response.data._embedded?.courses || [];
};

const createOrUpdateCourseImage = async ({ image, courseId }) => {
  const formData = new FormData();
  formData.append("image", image?.originFileObj);

  apiClient.interceptors.request.use((config) => {
    config.headers["Content-Type"] = "multipart/form-data";
    return config;
  });

  const response = await apiClient.put(
    `/cpd/courses/${courseId}/images`,
    formData
  );
  return response.data;
};

const createOrUpdateCourse = async ({ course }) => {
  const pathname = course?.uid ? `/cpd/courses/${course?.uid}` : `/cpd/courses`;
  if (course?.uid) {
    const response = await apiClient.put(`${pathname}`, {
      ...course,
    });
    return response.data;
  } else {
    const response = await apiClient.post(`${pathname}`, {
      ...course,
    });
    return response.data;
  }
};

const getQuizForCourseById = async (courseId, params) => {
  const response = await apiClient.get(`/cpd/courses/${courseId}/quiz`, {
    params,
  });
  return response.data;
};

const updateQuizForCourse = async ({ course, question }) => {
  const response = await apiClient.put(`/cpd/courses/${course?.uid}`, {
    uid: course?.uid,
    questions: [{ ...question }],
  });
  return response.data;
};

const deleteCourseById = async (courseId) => {
  const response = await apiClient.delete(`/cpd/courses/${courseId}`);
  return response.data;
};

export {
  fetchCbdCoursesById,
  fetchCpdContentCourses,
  createOrUpdateCourseImage,
  createOrUpdateCourse,
  deleteCourseById,
  getQuizForCourseById,
  updateQuizForCourse,
};
